import { withViewedCianIdsState } from './withViewedCianIdsState';
import { ICluster } from '../../repositories/dailyrent/entities/cluster/Cluster';
import { IOffer } from '../../repositories/dailyrent/entities/offer/Offer';
import { IFeaturesMap } from '../../types/map';
import { getMinPriceOffer } from '../../utils/getMinPriceOffer';

/** Объявление с ценой «от» - первым, остальные в порядке бэка */
function moveMinPriceOfferFirst(offers: IOffer[]): IOffer[] {
  const minPriceOffer = getMinPriceOffer(offers);

  if (!minPriceOffer || minPriceOffer === offers[0]) {
    return offers;
  }

  return [minPriceOffer, ...offers.filter(offer => offer !== minPriceOffer)];
}

// Мультипин: кластер не раскрывается в «ромашку», а становится одной фичей со всеми
// своими объявлениями. pinsCount = 1 даёт в сетке единственный центральный слот, поэтому
// раскрытие координат, anchor и zIndex работают как для одиночного пина без ветвлений.
// offersCount кормит каунтер, полный offers — цену «от», иконки и будущий слайдер превью.
// Порядок offers - порядок пина: первое открывается по клику, с него начинается листалка «1 / N»,
// по нему считаются позиции в аналитике.
export function convertClustersToMultipinFeaturesMap(
  clusters: ICluster[],
  viewedCianIds: Record<number, true>,
  isMinPriceOfferFirst: boolean,
): IFeaturesMap {
  return (
    clusters?.reduce<IFeaturesMap>((result, cluster) => {
      const { coordinates, geohash, offers } = cluster;

      if (!offers?.length) {
        return result;
      }

      const pinOffers = offers.map(offer => withViewedCianIdsState(offer, viewedCianIds));

      result[geohash] = {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [coordinates.lat, coordinates.lng],
        },
        id: geohash,
        properties: {
          ...cluster,
          pinIndex: 0,
          pinsCount: 1,
          offersCount: offers.length,
          offers: isMinPriceOfferFirst ? moveMinPriceOfferFirst(pinOffers) : pinOffers,
        },
      };

      return result;
    }, {}) ?? {}
  );
}
